import { stdObject } from "../../../data/types/stdObject";
import { emptysDates } from "../../../data/main";

const batchesQty = (e: stdObject) => {
  return e.TRABA0 > 0 ? e.TRABA0 + " / " + e.CANBA0 : e.CANBA0;
};

export default function writeBatchInfo(info: stdObject[]) {
  return (
    <div>
      <b>S/N: </b>
      <span>
        {info
          .map(
            (e: stdObject) =>
              `${e.CANBA0 === 1 ? "" : `(${batchesQty(e)}) `}${
                emptysDates.includes(e.EXPBAT) ? e.IDBA0 : e.EXPBAT
              }`,
          )
          .join(" / ")}
      </span>
    </div>
  );
}
